import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryCareDeleteAction from './veterinaryCareDelete.action.json' with { type: 'json' }
import { veterinaryCareObject } from '../veterinaryCareObject'

const veterinaryCareDeleteDefinition = defineAction({
  ...veterinaryCareDeleteAction,

  input: veterinaryCareObject.pick({
    id: true,
  }),
  output: z.object({}),
})

export default veterinaryCareDeleteDefinition
